import FlexViewBorder from "../../../components/FlexView/FlexViewBorder/FlexViewBorder";
import Separator from "../../../components/Separator";
import TitleBorderLeft from "../../../components/Text/TitleBorderLeft";
import BorderLeftBox from "../../../components/boxes/BorderLeftBox";
import TabsViewTwo from "../../../components/tabs/TabsViewTwo/TabsViewTwo";
import FemaleIcon from '../../../assets/icons/social/female.svg';
import FemaleTwoIcon from '../../../assets/icons/social/female-2.svg'
import MonyIcon from '../../../assets/icons/social/mony.svg';
import EducationIcon from '../../../assets/icons/social/education.svg';
import MonyIncrese from '../../../assets/icons/social/increse.svg';
import IncreseTwo from '../../../assets/icons/social/increase-2.svg';
import CupIcon from '../../../assets/icons/social/cup.svg';
import RocketIcon from '../../../assets/icons/social/rocket.svg';
import Academy from '../../../assets/icons/social/academy.svg';
import HandLeave from '../../../assets/icons/social/hande-leave.svg';
import Recycle from '../../../assets/icons/social/recycle.svg';
import SocialIcon2 from '../../../assets/icons/social/social-2.svg';
import Social1 from '../../../assets/images/social/social-1.jpg';
import Social2 from '../../../assets/images/social/social-2.jpg';
import Social3 from '../../../assets/images/social/social-3.jpg';
import Social4 from '../../../assets/images/social/social-4.jpg';
import Social5 from '../../../assets/images/social/social-5.jpg';
import Social6 from '../../../assets/images/social/social-6.jpg';

const tabsViewOneData = [
  <>
    <h2 className="text-title">Diversity</h2>
    <BorderLeftBox
      title="Gender diversity at SAB"
      subtitle="SAB stands as a leader in gender diversity in Saudi Arabia and views diversity promotion not only as a responsibility but as an essential requirement for sustained corporate growth in today’s dynamic world. We are committed to fostering gender diversity, starting from the highest leadership echelons and extending seamlessly through all organisational tiers. Our Board comprises a wellbalanced mix of skills, abilities, and expertise, featuring local and international members with extensive experience in financial and non-financial sectors. SAB was also the first listed company in Saudi Arabia to appoint a female Chair to the Board. In 2023, we appointed over 25 female members to senior management-level positions and Board Committees, marking a significant step toward the promotion of gender diversity within our organisation. At the end of 2023, the gender diversity statistics were as follows: "
    />
    <h2 className="text-paragraph">
      SAB is the standard-bearer for gender diversity in the Kingdom and the region:
    </h2>
    {/* <BorderCenterCard
      cards={[
        {
          title: "35.7%",
          subtitle: "women representation in Executive Management roles",
          subtitleThree: "In 2022,",
        },
      ]}
    /> */}
    <FlexViewBorder
      items={[
        {
          icon: {
            src: FemaleIcon,
            alt: "",
          },
          spanTwo: "SAB was the first listed company in Saudi Arabia to appoint a female Board Chair",
        },
        {
          icon: {
            src: FemaleTwoIcon,
            alt: "",
          },
          spanOne: "In 2023, we achieved",
          number: 50,
          unit: "%",
          spanTwo: "women representation in Executive Management roles "
        }
      ]}
    />
    <p className="text-paragraph">The active participation of
      women employees is supported through ambitious targets set across all
      business units. SAB’s workforce has shown a steady increase in female
      representation in the past few years, as shown below.
    </p>
    <TitleBorderLeft>Gender diversity statistics at year-end</TitleBorderLeft>
    <div className="space-25"></div>
    <div className="wrapper-mxw-720">
      <table className="table-secondary">
        <thead>
          <tr>
            <th aria-hidden="true"><span></span></th>
            <th aria-hidden="true"></th>
            <th className="td-e">2023</th>
            <th aria-hidden="true"></th>
            <th className="td-e">2022</th>
            <th aria-hidden="true"></th>
            <th className="td-e">2021</th>
          </tr>
          <tr>
            <th aria-hidden="true"></th>
            <th className="td-e">Male</th>
            <th className="td-e">Female</th>
            <th className="td-e">Male</th>
            <th className="td-e">Female</th>
            <th className="td-e">Male</th>
            <th className="td-e">Female</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Board</td>
            <td className="td-e bg-light-red"><b>10</b> <sup className="red-text a-mark">&#9398;</sup></td>
            <td className="td-e bg-light-red"><b>1</b> <sup className="red-text a-mark">&#9398;</sup></td>
            <td className="td-e">10</td>
            <td className="td-e">1</td>
            <td className="td-e">10</td>
            <td className="td-e">1</td>
          </tr>
          <tr>
            <td>Executive Management</td>
            <td className="td-e bg-light-red">10</td>
            <td className="td-e bg-light-red">5</td>
            <td className="td-e">10</td>
            <td className="td-e">5</td>
            <td className="td-e">9</td>
            <td className="td-e">5</td>
          </tr>
          <tr>
            <td>Senior Management</td>
            <td className="td-e bg-light-red">146</td>
            <td className="td-e bg-light-red">19</td>
            <td className="td-e">135</td>
            <td className="td-e">19</td>
            <td className="td-e">109</td>
            <td className="td-e">17</td>
          </tr>
          <tr>
            <td>Middle and Junior Management</td>
            <td className="td-e bg-light-red">2,741</td>
            <td className="td-e bg-light-red">945</td>
            <td className="td-e">2,730</td>
            <td className="td-e">810</td>
            <td className="td-e">2,799</td>
            <td className="td-e">766</td>
          </tr>
          <tr>
            <td>Total Full Time Employeest</td>
            <td className="td-e bg-light-red"><b>2,897</b> <sup className="red-text a-mark">&#9398;</sup></td>
            <td className="td-e bg-light-red"><b>969</b> <sup className="red-text a-mark">&#9398;</sup></td>
            <td className="td-e">2,875</td>
            <td className="td-e">834</td>
            <td className="td-e">2,917</td>
            <td className="td-e">768</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p className="text-note">Selected metrics marked with the <sup className="red-text a-mark">&#9398;</sup> symbol have been subject to independent limited assurance procedures by PricewaterhouseCoopers Public Accountants (‘PwC’)
      for the year ended 2023</p>
    <div className="space-50"></div>
    <BorderLeftBox
      title="Diversity statistics over time:"
      subtitle="Age and gender (excluding trainees, students, and outsourced staff)"
    />
    <div className="wrapper-mxw-720">
      <table className="table-secondary">
        <thead>
          <tr></tr>
          <tr className="border-bottom-red">
            <th aria-hidden="true"></th>
            <th className="td-e">2023</th>
            <th className="td-e">2022</th>
            <th className="td-e">2021</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total full-time employees<br></br>(excluding trainees, students, and outsourced staff)</td>
            <td className="td-e bg-light-red">3,866</td>
            <td className="td-e">3,709</td>
            <td className="td-e">3,705</td>
          </tr>
          <tr>
            <td>Age 18 - 30 years</td>
            <td className="td-e bg-light-red">684</td>
            <td className="td-e">615</td>
            <td className="td-e">485</td>
          </tr>
          <tr>
            <td>Age 30 - 50 years</td>
            <td className="td-e bg-light-red">2,950</td>
            <td className="td-e">2,891</td>
            <td className="td-e">3,036</td>
          </tr>
          <tr>
            <td>Age 51+</td>
            <td className="td-e bg-light-red">232</td>
            <td className="td-e">203</td>
            <td className="td-e">184</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>Women empowerment programmes</TitleBorderLeft>
    <p className="text-paragraph">The inclusion of women, in line with our ESG strategy’s diversity aspect, is a consistent thread that runs through in every major initiative, both internally in the Bank and through our societal contributions. A variety of social programmes are in place to empower women. </p>
    <p className="text-paragraph">Additionally, our “Khanzah Project” aims to enhance women’s financial independence through improved financial literacy, enabling better financial planning and management of daily expenses. In our dedication to enhancing the position of women in the workplace, we have also implemented various programmes at the bank level and have made significant social contributions. Moreover, our partnership with the “Al-Nhada Society” forms part of a nationwide strategy to bolster women’s support and promote financial literacy.</p>

    <FlexViewBorder
      items={[
        // {
        //   icon : {
        //     src : MonyIcon,
        //     alt : "",
        //   },
        //   spanTwo : "Al-Nahda project outcomes",
        // },
        {
          number: 124,
          spanTwo: "low-income participants in 2023",
        }, {
          number: 6,
          spanTwo: "money management training sessions hosted",
        }
      ]}
    />
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>Women Empowerment at SAB</TitleBorderLeft>
    <p className="text-paragraph">We believe that empowering women has profound social and economic implications. Women empowerment also improves organisational performance and fosters societal progress in alignment with Vision 2030. SAB actively supports numerous initiatives aimed at empowering women. The bank celebrates International Women’s Day each year, asking staff to participate in engaging activities such as trivia quizzes about inspirational women. </p>
    {/* <FlexViewBorder
      items={[
        {
          icon: {
            src: EducationIcon,
            alt: "",
          },
          spanTwo: "Educational classroom in King Fahad National Centre for children with cancer",
        }, {
          number: 317,
          spanTwo: "students"
        }
      ]}
    /> */}
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>Financial literacy</TitleBorderLeft>
    <p className="text-paragraph">During the month of Ramadan we launched a series of online awareness sessions geared towards different segments of society. This was led by SAB in partnership with the National Centre CSR (NCCSR). This campaign is aimed at raising awareness on savings, spending, investment, and financial fraud.</p>
    <FlexViewBorder
      items={[
        {
          icon: {
            src: MonyIncrese,
            alt: ""
          },
          spanTwo: "Financial literacy during Ramadan",
        }, {
          number: 40262,
          spanTwo: "female participants",
        }, {
          number: 44202,
          spanTwo: "male participants",
        }
      ]}
    />
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>Para-abled accelerator programme</TitleBorderLeft>
    <p className="text-paragraph">This was an initiative from the National Centre CSR (NCCSR) in partnership with SAB, Monsha’at and the Ministry of Human Resources. The programme covers a number of training sessions and workshops for para-abled citizens to enable them to be productive members of society and to start their own businesses. Qualified graduates will be supported by the Ministry to start up with their ideas / projects / businesses.</p>
    <FlexViewBorder
      items={[
        {
          icon: {
            src: IncreseTwo,
            alt: "",
          },
          spanTwo: "Para-abled accelerator programme"
        }, {
          number: 23093,
          spanTwo: "attendees online and offline"
        }, {
          number: 7,
          spanTwo: "sessions"
        }
      ]}
    />
    <div className="tabs-image-wrapper">
      <img src={Social1} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">Closing the regional savings gap</h2>
    <TitleBorderLeft>Riyali programme for financial literacy</TitleBorderLeft>
    <p className="text-paragraph">
      The Riyali programme is a SAB initiative to raise the level of financial literacy among Saudi nationals. We’ve partnered with the SEDCO Holding Group in this flagship social programme. Riyali imparts financial literacy and awareness by providing participants with the tools to make sound financial decisions while gaining financial management skills.
    </p>
    <p className="text-paragraph">
      This programme offers skills and educational courses covering the basics in financial planning, investing, saving, and inflation dynamics. Young people are also trained in the principles of Islamic borrowing and finance. Training modules include investment patterns, repayment of debt, and borrowing for investment. For entrepreneurial skilling, Riyali offers guidance to MSMEs on financial planning and risk assessment.
    </p>
    <p className="text-paragraph">
      In 2019, 560,000 recipients gained skills from short courses that included
      financial fundamentals such as budgeting, saving, understanding investment
      patterns and inflation, borrowing, and entrepreneurship. This highly
      popular programme engaged over 90,000 people in 2020, despite school and
      institutional closures to curb the spread of COVID-19 at the time.
      The Ministry of Education has endorsed its rollout in schools. With more
      than 400,000 beneficiaries, the programme is gaining significant reach in
      elevating financial literacy among future Saudi generations. In 2022, SAB
      and the Ministry of Education collaborated to launch a financial literacy
      competition for students.
    </p>
    <p className="text-paragraph">

    </p>
    <FlexViewBorder
      items={[
        {
          icon: {
            src: CupIcon,
            alt: "",
          },
          spanTwo: "Riyali invested in providing financial literacy courses in 2023",
        }, {
          number: 730000,
          spanTwo: "participants in the training"
        }, {
          number: 336260,
          spanTwo: "Primary-level students"
        }
      ]}
    />
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>

    <TitleBorderLeft>Taqadam programme</TitleBorderLeft>
    <p className="text-paragraph">
      A mentorship-driven start-up accelerator, Taqadam seeks to engage the next
      generation of MSME entrepreneurs for the Kingdom. We partner with the King
      Abdullah University of Science and Technology (KAUST) in the Taqadam
      programme to accelerate young entrepreneurs through a competition. Over
      the past 6 years, approximately 600 individuals have benefited from this
      programme which helps university-based entrepreneurs turn projects into
      prototypes and ideas into businesses.
      Promising entrepreneurs gain skills on how to validate the potential of a
      product or service idea as well as prototyping or modelling, engaging
      potential customers, and presenting to investor Stakeholders. Successfully
      presented business concepts receive funding from SAB, which also opens
      doors to accessing additional capital. The winning teams receive grant
      funding and access to working spaces.
    </p>
    <FlexViewBorder
      items={[
        {
          icon: {
            src: RocketIcon,
            alt: "",
          },
          spanTwo: "Taqadam",
        },
        {
          number: 150,
          spanTwo: "winners received SAR 150,000 each",
        },
        {
          number: 175,
          spanTwo: "teams participated",
        },
        {
          number: 600,
          spanTwo: "individuals",
        },
      ]}
    />
    <p className="text-paragraph">
      Over the past 4 years, the Taqadam accelerator has successfully graduated
      78 start-ups in sectors as diverse as healthcare, agriculture, gaming,
      consumer services, and education. Altogether, over SAR 9 million in
      funding has been provided. Several of these newly emerged enterprises have
      been short-listed at international technology and entrepreneurship
      competitions.
    </p>
    <p className="text-paragraph">
      The programme also provides participants with non-financial support. MSMEs
      are provided with mentorship and further training opportunities through a
      distinguished team of local and international trainers and consultants.
      The fifth cohort of the programme, set to take place in 2023, is expected
      to draw 60 teams from across all the Kingdom’s regions. Approximately SAR
      6 million in prize money will be shared among the next cohort of winning
      entrepreneurial teams.
    </p>
    <div className="tabs-image-wrapper">
      <img src={Social2} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">Advancing the ESG and sustainable finance market </h2>
    <BorderLeftBox
      title="Advocacy"
      subtitle="SAB’s standing in the market, combined with the international experience provided by our HSBC partnership, means that SAB is well-placed to help lead the ESG charge in the Kingdom’s financial sector. We are proud of our close relationship with various regulators. In engagements with these and other market players, we are advocating for the environmental, social and governance agenda across Saudi Arabia as we pursue Vision 2030."
    />
    <p className="text-paragraph">
      To promote the ESG cause, SAB has participated in notable sustainability forums and industry initiatives this year. SAB participated in COP 28 held in Dubai, UAE. The Bank also sponsored the UK-Saudi Renewable Energy Forum organised by the Saudi British Joint Business Council (SBJBC). This event took place in London and brought together a group of UK and Saudi ministers, senior government officials, and investors in interactive talks that discussed clean energy investment opportunities in the United Kingdom and the Kingdom of Saudi Arabia.
    </p>
    <div className="tabs-image-wrapper">
      <img src={Social3} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">Digitalisation</h2>
    <BorderLeftBox
      title="SAB’s digital journey"
      subtitle="SAB is dedicated to elevating analytical tools to give customers a more personalised experience. Through our SABnet and SABmobile platforms, we strive to cultivate a culture of flexibility, granting customers enhanced access to banking solutions in minimal time. Customers can conveniently conduct their everyday banking tasks from any location using our mobile application and net banking portal."
    />
    <p className="text-paragraph">
      Here’s a snapshot of our 2023 digital performance:
      <ul>
        <li>
          We offered more than 266 products, services, features through our digital channel to our 850,000 digitally active customers.
        </li>
        <li>
          We onboarded over 208,000 digital customers, with a digital adoption rate of 89%, marking a 5% increase from 2022.
        </li>
        <li>
          49 million transactions were conducted digitally in 2023.
        </li>
        <li>
          61,403 term deposit accounts have been opened, along with 23,000 credit cards, all through digital means.
        </li>
        <li>
          SAB 360° currently has 409,000 users.
        </li>
      </ul>
    </p>
    <p className="text-paragraph">
      Enhancing Our Capabilities with New Solutions Our achievements and initiatives this year include:
      <ul>
        <li>The introduction of the SAB 360° Learn Module, offering financial education to users of our app.</li>
        <li>Implementation of device registration with biometrics, ensuring the highest levels of security.</li>
        <li>Introduction of new digital wallets facilitating money transfers to beneficiaries’ M-pesa and AliPay wallets, enhancing customer convenience.</li>
        <li>Launching the SAB Store within the SABMobile app and website, enabling customers to purchase gift cards, vouchers, subscriptions, and other services seamlessly.</li>
      </ul>
    </p>
    <Separator />
    <TitleBorderLeft>SAB Digital Academy</TitleBorderLeft>
    <p className="text-paragraph">
      Established in 2017, the SAB Digital
      Academy has since been one of the
      bank’s flagship community development initiatives. In collaboration
      with Takamol Business Solutions, a
      business services consultancy, and
      the Financial Academy, an institute
      promoting financial knowledge, SAB
      has designed the Digital Academy
      to equip participants with essential
      skills and enhance their employment
      prospects.
      Aligned with the Kingdom’s Vision
      2030 objective of reducing unemployment rates and preparing young
      Saudi men and women for their careers, the programme offers a range
      of advanced upskilling courses at no
      cost.
    </p>
    <p className="text-paragraph">
      The programme offers various advanced free courses in several areas, including:
      <ul><li>Retail banking professional certification</li><li>Credit advisory</li><li>Anti-fraud and anti-money laundering</li><li>Soft skills and English courses</li></ul>
    </p>
    <p className="text-paragraph">
      Since its inception in 2017, approximately 600 men and women have
      successfully entered the labour
      market through the programme. The
      programme has expanded its initiatives to provide courses annually to
      around 8000 male and female participants. These courses, certified by
      the Financial Academy, will prepare
      participants for roles in the financial
      sector, including financial advisory
      and retail banking services.
    </p>
    <p className="text-paragraph">
      Furthermore, the programme
      celebrates excellence by acknowledging the top 400 male and female
      participants, allowing them to
      undertake the rigorous Financial
      Academy Exam upon completing
      their curriculum—an esteemed
      validation of their dedication and
      achievements.
    </p>
    <FlexViewBorder
      items={[
        {
          icon: {
            src: Academy,
            alt: "",
          },
          spanTwo: "SAB Digital Academy invested in providing financial literacy courses in 2023"
        },
        {
          number: 8000,
          spanTwo: "trainees by 2023",
        },
        {
          title: "Over 600",
          spanTwo: "individuals have entered the labour market",
        },
      ]}
    />
    <p className="text-paragraph">
      SAB’s collaboration with the Financial Academy enables more courses to be
      made digitally available. Since being established the Academy has
      qualified over 600 male and female trainees to enter the labour market.
      Training on offer includes subjects on combating fraud and money
      laundering, English language courses, and other workplace skills. Going
      forward, the top 400 male and female trainees will be allowed to take the
      Financial Academy exam.
    </p>
    <div className="space-50"></div>
    <Separator />
    <TitleBorderLeft>Spotlight: Seamless 2023</TitleBorderLeft>
    <p className="text-paragraph">
      The event “Seamless KSA 2023”
      took place at Riyadh Front in September 2023, spotlighting technology and innovation in banking,
      payments, fintech, e-commerce, and
      digital marketing. SAB showcased
      its capabilities and services, fostering connections with both the public
      and industry partners.</p>
    <Separator />
    <TitleBorderLeft>Impact and highlights:</TitleBorderLeft>
    <p className="text-paragraph">
      <ul><li>13 MoUs signed during
        Seamless with key partners
        to continue collaboration and
        engagement for delivering
        digitally driven solutions</li>
        <li>50+ account opening
          applications from corporate
          clients</li><li>Strong coverage on social
            media with 310k+ impressions
            and 6.2k+ engagements</li></ul></p>
    <Separator />
    <TitleBorderLeft>SAB’s Digital Vision for
      the Future:</TitleBorderLeft>
    <p className="text-paragraph">
      In recent years, we’ve been
      committed to advancing our
      “Digitising the Core” vision,
      making digital banking accessible
      to customers at their convenience.
      As part of this initiative, we’ve
      actively encouraged the use of our
      digital channels to welcome new
      customers to our products and
      services.
    </p><p className="text-paragraph">
      With the maturation of digital
      offerings and technology, our
      strategic focus has shifted towards
      aligning operations with our
      “Building for the Future” and
      “Accelerating Innovation” vision.
      This vision emphasises fostering
      partnerships that generate additional
      revenue through collaborations
      and marketplaces facilitated
      by Application Programming
      Interfaces (APIs). We aim to create
      new opportunities for growth and
      empower the new economy with a
      “Digital First” mindset.</p>
    <p className="text-paragraph">
      Moving forward, our efforts will
      be directed toward creating an
      “invisible experience” for our
      customers. This involves leveraging
      predictive analytics and hyperpersonalisation enabled by artificial
      intelligence and machine learningbased solutions in our interactions.</p>
    <Separator />
    <TitleBorderLeft>Cybersecurity</TitleBorderLeft>
    <h4 className="text-title-gray-background">Overview</h4>
    <p className="text-paragraph">
      Cybersecurity is a vital component
      of our risk management framework.
      SAB, therefore, constantly invests
      in improving threat detection and
      analysis, payment systems controls,
      data protection, backup, and recovery, amongst other topics.</p><p className="text-paragraph">
      Cybersecurity risks are governed
      at the senior management and
      board levels to ensure support for
      SAB’s cybersecurity programme
      at the highest level. An overall
      corporate-wide view of IT risk and
      governance is in effect across the
      bank. Cybersecurity governance
      activities encompass the periodic
      review and monitoring of SAB’s
      cybersecurity programme and managing information and cyber security
      risks.
    </p><p className="text-paragraph">
      Our cybersecurity strategy is
      underpinned by a comprehensive
      framework of policies and processes designed to uphold the highest
      standards of security:<ul><li>The Cybersecurity risk policy delineates rigorous cyber
        security assessments, robust
        identity and access management protocols, and meticulous
        cybersecurity risk mitigation
        considerations.</li><li>The data policy fosters vigilance
          in monitoring and controlling
          the movement of information,
          preemptively thwarting potential
          data security breaches.</li><li>Our cybersecurity policies and
            standards outline stringent
            measures and controls for
            safeguarding all forms of information and IT systems against
            unauthorised access, abuse,
            disclosure, modification, or
            destruction.</li></ul>
    </p>
    <h4 className="text-title-gray-background">
      Internal Audits and
      Penetration Testing
      Initiatives
    </h4>
    <p className="text-paragraph">
      In alignment with our commitment
      to transparency and accountability,
      SAB’s internal audit team conducts
      regular internal audits in collaboration with external auditors. The most
      recent audit, conducted in 4Q23,
      implemented the SAMA Cybersecurity Framework assessment focusing
      on three main pillars, i.e., design,
      implementation, and effectiveness.
      No significant concerns were highlighted, underscoring our ongoing
      diligence in upholding the highest
      standards of cybersecurity excellence and our firm commitment to
      prioritising both internal and regulatory requirements.
    </p><p className="text-paragraph">
      SAB also conducts regular penetration test exercises conducted by
      both in-house experts and external
      parties to bolster our security stance
      and meet regulatory standards.
      These tests aim to pinpoint network
      vulnerabilities proactively, enabling
      us to address them before potential
      exploitation by malicious actors. This
      ongoing vigilance allows the bank to
      maintain a keen eye on any infrastructure gaps and take preemptive
      measures.
    </p>
    <h4 className="text-title-gray-background">
      Prevent, detect, and mitigate
    </h4>
    <p className="text-paragraph">
      As part of Information Security Risk management, the Bank deploys various
      initiatives to improve its cybersecurity posture. The Bank also tracks its
      SAMA Cyber Threat Intelligence (CTI) principles for timely implementation.
      We have a cyber intelligence and threat analysis capability, which
      proactively collects and analyses external cyber information. Furthermore,
      SAB implements Vulnerability Management (VM) and Penetration Test (PT)
      programmes. The tests enable vulnerability scanning in all externally and
      internally facing assets to ensure timely detection and remedying of
      emerging information security risks. Our public-facing asserts undergo a
      more rigorous test as these are more prone to external attacks as compared
      to internal assets – we aim for zero vulnerabilities on external assets.
    </p>
    <p className="text-paragraph">
      In 2022, we further strengthened our cyber defences and enhanced our
      cybersecurity capabilities to help reduce the likelihood and impact of
      unauthorised access, security vulnerabilities being exploited, data
      leakage, third-party security exposure and advanced malware. These
      defences build upon a proactive data analytical approach to help identify
      advanced targeted threats.
    </p>
    <p className="text-paragraph">
      SAB’s Access Management Control ensures the protection of information
      assets from unauthorised users. The Access Management team also reviews
      access control (access recertification) to bank systems and users to
      ensure compliance with Access Management Control policies. In turn, SAB’s
      internal Information Security Risk Functional Instruction Manual provides
      a comprehensive policy for protecting all forms of information and
      information systems from unauthorised access, use, disclosure, disruption,
      modification, or destruction. This is undertaken to provide information
      confidentiality, integrity, and availability while tightening security
      controls against cyber threats. The Bank also has a Data Loss Prevention
      (DLP) Policy to monitor and control the movement of SAB information and
      deploys remedial actions to mitigate any data security breach.
    </p>
    <p className="text-paragraph">
      SAB experienced no cyber breaches in the last 3 years. As a testament to
      our robust information security controls, SAB achieved Payment Card
      Industry Data Security Standard (PCI DSS) certification in 2022. The
      PCI-DSS certificate, which is mandated by SAMA, is valid for 1 year and
      must be renewed annually. SAB is also 97% compliant with the NCA ECC
      Framework assessment according to the assessment conducted by the
      regulators. We are taking the necessary measures to improve the percentage
      to 100%.
    </p>
    <h4 className="text-title-gray-background">
      Cybersecurity awareness and training
    </h4>
    <p className="text-paragraph">
      Employees play a crucial role in fostering resilience against cybersecurity threats. Regular access rectification exercises mitigate access creep,
      keeping access to SAB systems
      within strict boundaries.
    </p>
    <p className="text-paragraph">
      At SAB, all employees are mandated
      to undergo cybersecurity training. In
      2023, the bank’s employees participated in trainings on:
      <ul>
        <li>Protecting our information</li>
        <li>Email security</li>
        <li>Remote access training</li>
        <li>NCA required organisational
          social media user awareness</li>
      </ul>
    </p>
    <p className="text-paragraph">
      The HR L&T teams track the completion percentage, and reports are
      shared with higher management
      for their information and necessary
      action.
    </p>
    <p className="text-paragraph">
      Our personnel regularly receive cybersecurity tips via emails, webinars,
      screensavers, SAB Mobile, and ATM
      screens. SAB conducts regular incident response drills such as phishing tests, fostering a risk-awareness
      culture. An extensive cybersecurity
      campaign was launched in October, targeting both SAB personnel
      and customers by utilising multiple
      social media platforms to enhance
      awareness further. Additionally, a
      dedicated cybersecurity session was
      provided to senior management in
      2023.
    </p>
    <p className="text-paragraph">
      Finally, we make sure our cybersecurity team is up to date with emerging technologies and give them the
      opportunity to complete courses
      and certifications that enhance
      their skills further. Additionally, SAB
      collaborates with esteemed cybersecurity advisories, ensuring access
      to top-tier consulting services and
      expert insights on emerging technologies, market shifts, threats, and
      preventive measures.
    </p>
    <div className="tabs-image-wrapper">
      <img src={Social4} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">Community initiatives </h2>
    <p className="text-paragraph">SAB contributes to a diverse range of social upliftment programmes for Saudi citizens. To widen our social reach, we partner with various organisations including charities, government agencies, and non-profit organisations. These partnerships yield more impactful results than would otherwise have occurred through solo SAB efforts.</p>
    <TitleBorderLeft>Saudi Food Bank</TitleBorderLeft>
    <p className="text-paragraph">
      While contemporary society treats food as a privately-owned commodity, it
      can also be a shared common good when reimagining a sustainable food
      system for a sustainable society. Food can be shared instead of being
      thrown away as waste. SAB advances the sharing of food in solidarity with
      underprivileged members of society. <br /> In 2022 the Bank, together with
      Eta’am, one of the leading NGOs involved in food preservation, established
      the first-ever dry-food preserving food bank in the country. Operating in
      Riyadh, a central kitchen equipped with the essential technologies to
      preserve surplus dry food regularly supplies meals to social security
      families, people with disabilities, and orphans.
    </p>
    <p className="text-paragraph">
      SAB’s financial contribution to the programme covers the costs of the
      project's construction, operation, and logistics, while Eta'am facilitates
      the project's implementation and management. This programme will also
      develop long-term partnerships with food companies that see value in
      preserving dry foods and turning them into ready-to-eat meals. Our
      ambitious target is to save more than 500,000 tonnes of dry and canned
      foods, which will contribute significantly to food security.
    </p>
    <FlexViewBorder
      items={[
        {
          icon: {
            src: HandLeave,
            alt: "",
          },
          spanTwo: "Saudi Food Bank invested in preserving dry foods in 2022",
        },
        {
          number: 400000,
          spanTwo: "meals provided",
        },
        {
          number: 500000,
          spanTwo: "tonnes of food preserved",
        },
      ]}
    />
    <p className="text-paragraph">
      Another initiative from Eta’am, is to repackage and distribute 100,000
      meals to 6,000 registered families in need throughout the 6 months of the
      Riyadh Season. <br /><br />
      To date, we have distributed 11,231 meals and 70 food baskets containing
      dry and canned goods to needy families in Riyadh. This project expands on
      SAB and Eta’am’s strategic partnership, in which SAB will continue to
      support Eta’am Bank’s initiatives and projects in the field of food
      preservation, as well as provide support to partnerships, raise awareness
      among community organisations, and solidify the concept of social
      solidarity.
    </p>

    <FlexViewBorder
      items={[
        {
          icon: {
            src: Recycle,
            alt: "",
          },
          spanTwo: "Saudi Food Bank invested in preserving and distributing ready-made meals in 2022",
        }, {
          number: 100000,
          spanTwo: "meals",
        },
        {
          number: 70,
          spanTwo: "food baskets",
        },
        {
          number: 120,
          spanTwo: "tonnes of food",
        }
      ]}
    />
    <p className="text-paragraph">
      In addition, SAB recognises that benevolence to others is a spiritual
      virtue, especially during the holy month of Ramadan. During the recent
      holy month of Ramadan we collaborated with 12 charities to reach
      low-income families through this SAB Ramadan Basket initiative.
    </p>
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>Tarmeem programme</TitleBorderLeft>
    <p className="text-paragraph">
      The right to shelter is globally recognised – safe housing is imperative
      for a person’s wellbeing. The Tarmeem programme supports the construction
      and renovation of houses for needy families. This initiative depends on
      fieldwork undertaken by Bank and specialised teams that search for
      families requiring assistance.
    </p>
    <FlexViewBorder
      items={[
        {
          icon: {
            src: SocialIcon2,
            alt: "",
          },
          spanTwo: "Tarmeem programme final payment in 2022"
        },
        {
          number: 18,
          spanTwo: "houses",
        },
      ]}
    />
    <div className="tabs-image-wrapper">
      <img src={Social5} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">Our workforce: The bedrock of our success</h2>
    <p className="text-paragraph">SAB is proud of its high-quality team. Our employees are what make us successful and enable the implementation of an ESG strategy that promotes the wellbeing of society and the planet. SAB takes care of its people, and it shows – our annual employee survey showed a 73% employee engagement score, an improvement of 15% from 2021. </p>
    <div className="wrapper-mxw-720">
      <table className="table-secondary">
        <thead>
          <tr></tr>
          <tr>
            <th>Our people in numbers</th>
            <th className="td-e">2023</th>
            <th className="td-e">2022</th>
            <th className="td-e">2021</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total full-time employees<br></br>(excluding trainees, students and outsourced staff)</td>
            <td className="bg-light-red td-e">3,866</td>
            <td className="td-e">3,709</td>
            <td className="td-e">3,705</td>
          </tr>
          <tr>
            <td>Indefinite/permanent contract employees</td>
            <td className="bg-light-red td-e">2,517</td>
            <td className="td-e">2,540</td>
            <td className="td-e">2,639</td>
          </tr>
          <tr>
            <td>Fixed/temporary contract employees</td>
            <td className="bg-light-red td-e">1,349</td>
            <td className="td-e">1,169</td>
            <td className="td-e">1,066</td>
          </tr>
          <tr>
            <td>Trainees and sponsored students</td>
            <td className="bg-light-red td-e">53</td>
            <td className="td-e">97</td>
            <td className="td-e">109</td>
          </tr>
          <tr>
            <td>Number of nationalities represented </td>
            <td className="bg-light-red td-e">28</td>
            <td className="td-e">29</td>
            <td className="td-e">28</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 className="text-title-gray-background">Hiring and turnover</h4>
    <p className="text-paragraph">
      Staff turnover in an important indicator of employee engagement and
      business growth. SAB’s employee numbers have grown steadily over the past
      few years. While the COVID-19 pandemic contributed to greater employee
      turnover in 2021, that trend has reversed itself and employee churn has
      reduced.
    </p>
    <div className="wrapper-mxw-720">
      <table className="table-secondary text-direction-left">
        <tr>
          <th>New Hires and Turnover</th>
          <th>2023</th>
          <th>2022</th>
          <th>2021</th>
        </tr>
        <tr>
          <td>Total new hires</td>
          <td>537</td>
          <td>440</td>
          <td>342</td>
        </tr>
        <tr>
          <td>Male</td>
          <td>294</td>
          <td>277</td>
          <td>223</td>
        </tr>
        <tr>
          <td>Female</td>
          <td>243</td>
          <td>163</td>
          <td>119</td>
        </tr>
        <tr>
          <td>Age 18 - 30</td>
          <td>342</td>
          <td>239</td>
          <td>160</td>
        </tr>
        <tr>
          <td>Age 31 - 50</td>
          <td>192</td>
          <td>198</td>
          <td>175</td>
        </tr>
        <tr>
          <td>Age 51+</td>
          <td>3</td>
          <td>3</td>
          <td>7</td>
        </tr>
        <tr>
          <td>Total employee turnover (voluntary and involuntary)</td>
          <td>361</td>
          <td>464</td>
          <td>652</td>
        </tr>
        <tr>
          <td>Male</td>
          <td>265</td>
          <td>346</td>
          <td>512</td>
        </tr>
        <tr>
          <td>Female</td>
          <td>96</td>
          <td>118</td>
          <td>140</td>
        </tr>
        <tr>
          <td>Age 18 - 30</td>
          <td>86</td>
          <td>86</td>
          <td>65</td>
        </tr>
        <tr>
          <td>Age 31 - 50</td>
          <td>243</td>
          <td>319</td>
          <td>400</td>
        </tr>
        <tr>
          <td>Age 51+</td>
          <td>32</td>
          <td>59</td>
          <td>187</td>
        </tr>
      </table>
    </div>
    <p className="text-paragraph">We are pleased to report that according to the Banking Survey conducted through Almultaka (Saudi Banks Human Resource Forum), SAB has the lowest level of staff turnover in 2022 amongst the following KSA banks:</p>
    <div className="wrapper-mxw-720">
      <table className="table-secondary text-direction-left">
        <thead>
          <tr></tr>
          <tr>
            <th aria-hidden="true"></th>
            <th>GIB</th>
            <th>AlBilad Bank</th>
            <th>ANB</th>
            <th>Riyadh</th>
            <th>Alinma Bank</th>
            <th>BSF</th>
            <th>SAB</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Overall staff turnover</td>
            <td>12.9%</td>
            <td>15.1%</td>
            <td>13.3%</td>
            <td>13.2%</td>
            <td>13.41%</td>
            <td>13.9%</td>
            <td>12.6%</td>
          </tr>
          <tr>
            <td>Regrettable turnover from the regrettable pool</td>
            <td>9.7%</td>
            <td>12.0%</td>
            <td>8.7%</td>
            <td>9.9%</td>
            <td>7.9%</td>
            <td>12.1%</td>
            <td>7.3%</td>
          </tr>
        </tbody>
      </table>
    </div>
    <Separator />
    <h4 className="text-title-gray-background">Nationalisation</h4>
    <p className="text-paragraph">
      Reducing the number of unemployed Saudi nationals is a key part of Vision
      2030. SAB is proud that over 90% of its employees are Kingdom nationals.
      We do however acknowledge the importance of diversity and gain from the
      varied skills and experiences brought by the people from 29 nations within
      our ranks.
      <br /> As part of our drive to support the recruitment and retention of
      Saudi employees, SAB promotes graduate programmes for Saudi nationals and
      implements development plans for existing employees
    </p>
    <div className="wrapper-mxw-720">
      <table className="table-secondary text-direction-left">
        <thead>
          <tr></tr>
          <tr>
            <th>Saudisation</th>
            <th>2020</th>
            <th>2021</th>
            <th>2022</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Nationalisation of Senior Management (%)</td>
            <td>65%</td>
            <td>66%</td>
            <td className="bg-light-red">66%</td>
          </tr>
          <tr>
            <td>Nationalisation among total workforce (%) </td>
            <td>90.6%</td>
            <td>90.6%</td>
            <td className="bg-light-red">90.1%</td>
          </tr>
          <tr>
            <td>Total number of national employees</td>
            <td>3,674</td>
            <td>3,358</td>
            <td className="bg-light-red">3,341</td>
          </tr>
          <tr>
            <td>Number of female national employees</td>
            <td>799</td>
            <td>781</td>
            <td className="bg-light-red">825</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p className="text-paragraph">
      In 2022, SAB celebrated the graduation of 19 trainees from our 2021 SAB Graduate programme, after which
      all of the candidates joined the Company full-time. We launched our SABTech Graduate programme for technology graduates, in which 24 graduates are participating. In 2023, we also launched the SAB Corporate Banking Graduate programme, through which the Bank has an intake of 20 graduates from a financial background.
    </p>
    <Separator />
    <h4 className="text-title-gray-background">
      Supporting a culture of employee wellness and engagement
    </h4>
    <p className="text-paragraph">
      It is important to SAB that its employees feel motivated and engaged at
      work. SAB is therefore pleased to note the upward trajectory of its
      employee engagement score resulting from the 2022 employee survey, in
      which 99% of our workforce participated <br /> <br />
    </p>
    <div className="wrapper-mxw-720">
      <table className="table-secondary text-direction-left">
        <thead>
          <tr aria-hidden="true"></tr>
          <tr>
            <th aria-hidden="true"></th>
            <th>2020</th>
            <th>2021</th>
            <th>2022</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Employee engagement (%)</td>
            <td>SAB: 58%<br />Alawwal Bank: 72%</td>
            <td>56%</td>
            <td>73%</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p className="text-paragraph">
      In addition to the employee engagement score, the 2022 survey also
      highlighted that: <br />
      <ul>
        <li>
          73% of employees are satisfied with the continued evolution of our
          culture and engagement at SAB, a 17% increase on 2022
        </li>
        <li>
          77% of all employees confirmed their strong awareness and commitment
          to the Bank’s strategy, a 14% increase on 2022
        </li>
      </ul>
      <br />
      <br />
      SAB takes employee feedback very seriously, especially considering the
      evolution of the Bank’s culture at present. Following the 2019 merger with
      Alawwal Bank, SAB took the opportunity to reassess its organisational
      culture, keeping in mind the demographics of the Kingdom and the shift in
      social norms. A survey on organisation culture was undertaken to provide
      baseline insights into future people-culture-fit decisions. Results from
      the assessment created a good foundation to start building a new
      organisational culture that draws on the legacies of both the merging
      companies. In 2020, we rolled out a corporate-wide initiative to enable an
      organisational culture to emerge that dovetails the SAB brand.
      <br /><br />
      Advancing employee potential and excellence is a key attribute of SAB’s
      organisational culture. It permeates how we recruit, retain, and embark on
      Staff development. Recruiting and promoting employees is based on merit
      and ability within the context of an open and supportive environment in
      which everyone can thrive. Our ethos of advancing inclusion compels us to
      solicit employees’ ideas in shaping workplace business solutions,
      resulting in a vibrant working environment. According to LinkedIn’s
      ranking for the best companies in 2022, SAB was ranked among the top
      workplaces to grow a career in Saudi Arabia. <br />
      <br /><br />
      Several attributes make SAB an attractive workplace. These include:
      <ul>
        <li>
          A holistic reward strategy that includes fixed pay, wide-ranging
          benefits, bonuses, and incentives
        </li>
        <li>
          A commitment to employ locals, with the percentage of indigenous Saudi
          Staff increasing from 47% in 1990 to over 90% in 2022
        </li>
        <li>
          Staff training and development opportunities, among the best available
          in the Kingdom’s banking industry
        </li>
        <li>
          An attractive reward package that is reviewed regularly to ensure we
          remain competitive in the market
        </li>
        <li>
          Continuous reskilling through learning programmes that leverage our
          collaboration with HSBC as a leading international banking group
        </li>
        <li>Specialised training programmes for high potential employees.</li>
      </ul>
      <br /><br />
      Our organisational culture includes the 4 touchstone values of
      customer-centricity, collaboration, innovativeness, and doing the right
      thing. These are at the heart of everything the Bank does. From helping a
      customer make their first home purchase to making senior leadership
      appointments, from choosing the right vendor for a future IT system to
      appraising the performance of an employee – our core values are upheld to
      enable service excellence. <br /><br />
      In turn, we offer a generous and continuously updated reward proposition
      to employees. We have reshaped our incentive and bonus schemes to motivate
      employees to create the best outcomes for customers. Staff performance is
      measured by outputs that are linked to customer satisfaction. Our
      recognition and reward approach is in line with both SAMA's rules on
      compensation and the Financial Stability Board guidelines.
      <br /><br />
      Following the merger with Alawwal Bank, SAB partnered with Accenture to
      undertake the first-ever mental wellbeing initiative in Middle East
      banking. Approximately 50 webinars on mental health and mindfulness were
      held as part of this initiative. This exercise was well-timed to engage
      the mental health consequences emanating from the intense socially
      distressing period of the COVID-19 pandemic.
      <br />
      <br />
      In 2022, we launched personalised CEO sessions under the title “Connect
      with Tony”, allowing Staff to meet with the Managing Director and CEO
      personally and engage in conversations around the future direction of the
      Bank. Following the successful rollout of these sessions, the Bank
      expanded the meetings to include the Management Committee. SAB hosted
      more than 10 events across its regions, including a memorable concert that
      introduced a different experience and garnered a greater than 90% approval
      rating from employees.
      <br />
      <br />
      Other employee calendar events, geared to appreciate and support while
      raising awareness of important issues, include a meet and greet with
      Fintech Saudi, an International Women’s Day seminar, and the SAB INNOVATE
      programme. In 2022, SAB recognised 637 employees who reached a milestone
      work anniversary with the organisation, having completed 5, 10, 15, 20, 25
      and 30 years as of 2021.
      <br />
      We continue to set targets and milestones to push our culture agenda
      forward in line with the growth taking place in the Bank and the Kingdom
      as a whole.
      <br />
    </p>
    <Separator />
    <h4 className="text-title-gray-background">
      Training and career development
    </h4>
    <p className="text-paragraph">The following table outlines the training undergone by our full-time employees, and excludes mandatory training and additional training concluded through LinkedIn and Coursera.</p>
    <div className="wrapper-mxw-720">
      <table className="table-secondary text-direction-left">
        <thead>
          <tr></tr>
          <tr>
            <th className="mw-50">Training</th>
            <th className="mw-50">2020<sup>1</sup></th>
            <th className="mw-50">2021</th>
            <th className="mw-50">2022</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total training delivered (days)<sup>2</sup></td>
            <td>1,043</td>
            <td>9,201</td>
            <td className="bg-light-red">9,783</td>
          </tr>
          <tr>
            <td>Total training delivered (hours)<sup>3</sup></td>
            <td>6,255</td>
            <td>55,206</td>
            <td className="bg-light-red">58,700 <sup className="red-text a-mark">&#9398;</sup></td>
          </tr>
          <tr>
            <td>- Senior Management employees </td>
            <td>25</td>
            <td>71</td>
            <td className="bg-light-red">101</td>
          </tr>
          <tr>
            <td>- Middle Management employees </td>
            <td>110</td>
            <td>975</td>
            <td className="bg-light-red">1,104</td>
          </tr>
          <tr>
            <td>- Non-management employees </td>
            <td>128</td>
            <td>1,673</td>
            <td className="bg-light-red">1,441</td>
          </tr>
          <tr>
            <td>- Male employees</td>
            <td>160</td>
            <td>2,134</td>
            <td className="bg-light-red">2,005</td>
          </tr>
          <tr>
            <td>- Female employees</td>
            <td>103</td>
            <td>585</td>
            <td className="bg-light-red">641</td>
          </tr>
          <tr>
            <td>Average training per employee (days)</td>
            <td>0.25</td>
            <td>2.48</td>
            <td className="bg-light-red">2.6</td>
          </tr>
          <tr>
            <td>- Senior Management employees</td>
            <td>0.17</td>
            <td>0.51</td>
            <td className="bg-light-red">0.60</td>
          </tr>
          <tr>
            <td>- Middle Management employees</td>
            <td>0.08</td>
            <td>0.79</td>
            <td className="bg-light-red">0.82</td>
          </tr>
          <tr>
            <td>- Non-management employees</td>
            <td>0.049</td>
            <td>1.2</td>
            <td className="bg-light-red">0.65</td>
          </tr>
          <tr>
            <td>- Male employees</td>
            <td>0.049</td>
            <td>0.73</td>
            <td className="bg-light-red">0.61</td>
          </tr>
          <tr>
            <td>- Female employees</td>
            <td>0.12</td>
            <td>0.74</td>
            <td className="bg-light-red">0.76</td>
          </tr>
          <tr>
            <td>Average training per employee (hours)</td>
            <td>20</td>
            <td>36</td>
            <td className="bg-light-red">36</td>
          </tr>
          <tr>
            <td>Number of attendees who completed at least one e-learning course</td>
            <td>4,045</td>
            <td>3,705</td>
            <td className="bg-light-red">3,709</td>
          </tr>
          {/* <tr>
          <td>Number of e-learning training hours delivered</td>
          <td>0</td>
          <td>0</td>
          <td className="bg-light-red">0</td>
        </tr> */}
          <tr>
            <td>Number of employees who completed sustainability awareness e-learning programme</td>
            <td></td>
            <td></td>
            <td className="bg-light-red"></td>
          </tr>
          <tr>
            <td>- ESG Module 1</td>
            <td>0</td>
            <td>0</td>
            <td className="bg-light-red">2,633</td>
          </tr>
          <tr>
            <td>- ESG Module 2</td>
            <td>0</td>
            <td>0</td>
            <td className="bg-light-red">2,484</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p className="text-note">
      <sup className="red-text a-mark">&#9398;</sup> This metric for the year ended 31 December 2022 was subject to independent limited assurance by PricewaterhouseCoopers Public Accountants (‘PwC’) For further details, see our Reporting criteria and PwC's limited assurance report, which are available at website link to be added here<br />
      <sup>1</sup> Due to COVID19 there were a lower number of trainings conducted during 2020 <br />
      <sup>2</sup> Total hours of training per year / number of hours per one course (6 hours) <br />
      <sup>3</sup> Total hours of training per year extracted from learning management solutions (LMS)
    </p>
    <p className="text-paragraph">
      SAB ensures that its employees are upskilled according to the Bank’s
      requirements, following a learning needs analysis that also balances
      employees’ personal objectives. Our 2022 training included: <br />
      <ul>
        <li>
          A customised cross-selling workshop for front-line Business
          Relationship Managers and leaders
        </li>
        <li>
          SAB’s Enterprise Risk Leadership programme for the top 30 Executives
          in the Bank
        </li>
        <li>
          Accelerating into Leadership, a junior manager’s development programme
          to prepare participants for senior management roles
        </li>
        <li>SAB Graduate programme</li>
        <li>ESG and digital learning programmes</li>
        <li>
          LinkedIn, Coursera and mandatory trainings are not captured in the training data above
        </li>
      </ul>{" "}
      <br /> <br />
      We placed special focus on raising awareness and skills in ESG areas
      across the Bank in 2022. SAB’s senior leadership received off-site
      training on ESG topics and how they relate to the Bank and the Kingdom.
      The SAB Corporate Banking Relationship Managers working with the oil and
      gas industry also received ESG training around the direction of finance
      activities in this sector. In addition, ESG e-learning modules have been
      rolled out to Staff members across the Bank – 70% of employees have
      completed this training so far.
    </p>
    <Separator />
    <h4 className="text-title-gray-background">Development planning</h4>
    <p className="text-paragraph">
      Development Planning at SAB is an ongoing process between the employee
      and the line manager aimed at gaining knowledge and improving skills while
      providing the employee with opportunities to advance their career.
      Employee Development Planning is aligned with the organisation’s needs and
      individual career aspirations.
      <br /><br /> Development plans are available to all employees. SAB provides a
      framework to the employee and their manager to help the delivery of and
      participation in appropriate development activities, therefore supporting
      employee progression and succession. The Development planning include
      formal training, rotation / on-the-job training and exposure to
      cross-functional organisational processes.
    </p>
    <p className="text-paragraph">
      The development plan focuses on identifying and addressing three potential gaps: There are 3 main areas that the development plan focuses on are:
    </p>
    <div className="wrapper-mxw-720">
      <table className="table-secondary">
        <thead>
          <tr></tr>
          <tr>
            <th>Key Gap Area</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Technical Knowledge</td>
            <td>The person may not have sufficient knowledge and hands-on experience in all products and functions under the scope of their current or target role, including product/function related market dynamics, customers, financials, risk management, or compliance/regulations, etc. </td>
          </tr>
          <tr className="bg-blue">
            <td>Organisational Knowledge</td>
            <td>The person may not have sufficient knowledge and hands-on experience in all the internal and external organisational linkages related to their current or target role, including cross-selling, business/control/support functional interdependencies, relations with regulators, customer forums, and decision-making apparatus (such as hierarchy, process, and committees).</td>
          </tr>
          <tr>
            <td>Leadership Requirements</td>
            <td>The person may not have sufficient exposure to managing larger and more complex teams related to their current or target role. The dynamics of providing a vision, embracing diversity and inclusion, organizing, engaging, motivating, and managing change is generally more complex with larger teams. </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 className="text-title-gray-background">Employee benefits</h4>
    <p className="text-paragraph">
      SAB supports its employees with a range of benefits designed to support a happy, healthy workforce. Benefits are applied in terms of an employee’s Global Career Band (GCB), which determines the most senior employees (GCB 0) until the most junior (GCB 8). Benefits include the following:
    </p>

    <TabsViewTwo
      headers={[
        "Allowances and finance",
        "Leave",
        "Medical insurance",
        "Other benefits",
      ]}
      data={[
        <>
          <div className="space-25"></div>
          <h3 className="text-title-two red-text">Child education allowance</h3>
          <p className="text-paragraph">
            GCB 0 to 4 employees are eligible to receive education support for
            up to four children aged between five and 19 years regardless of
            where they are being educated.
            <br /> <br />
            The allowance per child per annum is:
            <ul>
              <li>GCB 4: SAR 20K</li>
              <li>GCB 1-3: SAR 25K</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Day care allowance</h3>
          <p className="text-paragraph">
            All female employees with children younger than six years old are
            entitled to this allowance.<br /><br /> The allowance per child per annum is SAR
            12,000.
          </p>
          <Separator />
          <h3 className="text-title red-text">Home finance</h3>
          <p className="text-paragraph">
            Over and above the monthly housing allowance provided to SAB
            employees (25% of the basic salary), SAB offers the Tayseer
            programme for home financing to Saudi employees with existing home
            loans. The programme supports eligible employees by reimbursing
            financings costs above 1% on a qualified real estate.
          </p>
        </>,
        <>
          <div className="space-25"></div>
          <h3 className="text-title-two red-text">Annual leave</h3>
          <p className="text-paragraph">
            All employees are entitled to annual leave, according to the
            following:
            <ul>
              <li>GCB 0-6: 30 working days per annum</li>
              <li>GCB 7-8: 26 working days per annum</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Sick leave</h3>
          <p className="text-paragraph">
            All employees are entitled to take a leave of absence when they are
            too ill to work, according to the following:
            <ul>
              <li>Up to 30 days’ leave with full pay</li>
              <li>The following 60 days are at 75% pay</li>
              <li>The following 30 days are at 50% pay</li>
              <li>The following 60 days are at 25% pay</li>
            </ul>
            After 180 days, sick absence leave is unpaid.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Work related injury leave</h3>
          <p className="text-paragraph">
            Should employees be injured while at work, they are entitled to
            take:
            <ul>
              <li>Up to 60 days’ leave with full pay</li>
              <li>From 61 days to one year’s leave at 75% pay.</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Statutory leave</h3>
          <p className="text-paragraph">
            All employees are entitled to take statutory leave with full pay for
            Eid Al Fitr, Eid Al Adha, Foundation Day and Saudi National Day.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Haj leave</h3>
          <p className="text-paragraph">
            Employees who have completed two years of service are entitled to
            take six days paid leave, in addition to Eid Al Adha holiday, once.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Parental leave</h3>
          <p className="text-paragraph">
            All employees with newborn children are entitled to the following
            paid parental leave:
            <ul>
              <li>14 calendar weeks for the mother</li>
              <li>Five working days for the father</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Study leave</h3>
          <p className="text-paragraph">
            All employees furthering their education are eligible to take five
            working days’ paid leave to focus on their studies, and one day for
            each examination sitting.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Compassionate leave</h3>
          <p className="text-paragraph">
            All employees who suffer the loss or severe illness of a close
            family member is entitled to five working days’ paid leave.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Mourning Leave</h3>
          <p className="text-paragraph">
            All female employees who suffer the loss of a husband are entitled
            to paid mourning leave:
            <ul>
              <li>Muslim females: Four months and 10 calendar days</li>
              <li>Non-Muslim females: 15 calendar days</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Emergency leave</h3>
          <p className="text-paragraph">
            While SAB allows for leave to be taken when an employee faces an
            emergency, this leave is unpaid.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Marriage leave</h3>
          <p className="text-paragraph">
            All newlywed employees are entitled to five working days’ paid
            leave.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Companion leave</h3>
          <p className="text-paragraph">
            All married employees are entitled to two working days’ paid leave
            per annum.
          </p>
        </>,
        <>
          <h3 className="text-paragraph">SAB provides the following medical insurance to employees based on the benefits and criterial determined by our medical insurance partner and underwriter.</h3>
          <Separator />
          <h3 className="text-title-two red-text">
            Family medical support for deceased employees
          </h3>
          <p className="text-paragraph">
            SAB provides a special discounted rate for medical insurance to KSA
            employee, to support their dependents in the unfortunate event that
            they pass away. The Bank will continue enrolling dependents and
            cover the insurance premiums for two years after the death of an
            employee.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Personal accident insurance</h3>
          <p className="text-paragraph">
            All employees up to the age of 65 years (and above, subject to
            certain special medical tests and approvals) are covered by a Group
            Personal Accident Insurance Policy against death and permanent or
            partial disability caused by sickness or accidents whilst using any
            means of transportation for business or private travel. Should an
            employee suffer permanent disability or death, a lump sum of between
            SAR 500,000 and SAR 5 million is paid out.
            <br />
            Employees have the option of taking out additional life or
            disability insurance cover.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Public liability insurance</h3>
          <p className="text-paragraph">
            This insurance cover provides against liability at law for damages
            and claimant's cost and expenses in respect of accidental injury to
            employees and accidental damage to property other than injury to
            employees or any claim arising under the Saudi Labour Law.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">GOSI occupational hazard insurance</h3>
          <p className="text-paragraph">
            The Saudi General Organisation for Social Insurance (GOSI), under
            the Saudi Social Insurance Law, provides mandatory insurance cover
            against injuries from work-related accidents applied as compensation
            to all employees.
            <br /> Coverage is set out for Saudi nationals and expatriate
            employees.
          </p>
        </>,
        <>
          <div className="space-25"></div>
          <h3 className="text-title-two red-text">Remote working</h3>
          <p className="text-paragraph">
            SAB is committed to ensuring that its working practices, physical
            work location and working hours provide employees with flexibility
            and autonomy that meets both the needs of the business and
            employees.
            <br /> In doing so, SAB recognizes that a better work life balance
            can improve employee motivation, performance and productivity and
            reduce stress.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">Job transfers</h3>
          <p className="text-paragraph">
            SAB encourages internal mobility and career development
            opportunities for all employees through internal job transfers
            between businesses and functions. Job transfers are managed through
            internal resourcing channels and support the continued professional
            development of all employees and support the Bank in meeting its
            resourcing needs.
          </p>
        </>,
      ]}
    />
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <h4 className="text-title-gray-background">Return from parental leave</h4>
    <p className="text-paragraph">A measure of employee engagement is the return-to-work rate following parental leave. We saw an improvement in our return-to-work rates in 2022. </p>
    <div className="wrapper-mxw-720">
      <table className="table-secondary text-direction-left">
        <thead>
          {/* <tr></tr> */}
          <tr className="border-bottom-red">
            <th>Parental leave </th>
            <th>2020</th>
            <th>2021</th>
            <th>2022</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Number of female employees that took parental leave</td>
            <td>34</td>
            <td>39</td>
            <td className="bg-light-red">27</td>
          </tr>
          <tr>
            <td>Number of female employees who returned to work after parental leave ended (return to work)</td>
            <td>28</td>
            <td>34</td>
            <td className="bg-light-red">26</td>
          </tr>
          <tr>
            <td>Number of female employees who returned from parental leave who were still employed 12 months after returning to work (retention)</td>
            <td>28</td>
            <td>34</td>
            <td className="bg-light-red">26</td>
          </tr>
          <tr>
            <td>Return to work rate (%)</td>
            <td>82%</td>
            <td>87%</td>
            <td className="bg-light-red">96%</td>
          </tr>
          <tr>
            <td>Retention rate (%)</td>
            <td>18%</td>
            <td>13%</td>
            <td className="bg-light-red">4%</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 className="text-title-gray-background">Non-discrimination</h4>
    <p className="text-paragraph">Every employee receives compulsory e-learning annually on dealing with and reporting harassment in the workplace, which 98.03% of employees completed in 2022. Several avenues are available for those employees who need to raise grievances or concerns. A whistleblowing hotline is available to staff members, should any employee feel that they or their colleagues are subject to discrimination or harassment, and an independent investigation team is trained to respond to such instances in an independent and objective manner. A formal grievance policy is in place for Management to handle grievances raised appropriately, with oversight of specific cases by the Risk Management and Conduct Management Committees.</p>
    <div className="tabs-image-wrapper">
      <img src={Social6} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
];

export default tabsViewOneData;
